// `fontPackage` is read server-side to inline the woff2, so PDFs match what the browser rendered.
export const SIGNATURE_FONTS = [
    {
        key: 'dancing_script',
        label: 'Flowing',
        family: 'Dancing Script',
        fontPackage: '@fontsource/dancing-script',
    },
    {
        key: 'great_vibes',
        label: 'Formal',
        family: 'Great Vibes',
        fontPackage: '@fontsource/great-vibes',
    },
    {
        key: 'homemade_apple',
        label: 'Handwritten',
        family: 'Homemade Apple',
        fontPackage: '@fontsource/homemade-apple',
    },
    {
        key: 'caveat',
        label: 'Casual',
        family: 'Caveat',
        fontPackage: '@fontsource/caveat',
    },
];
export const SIGNATURE_FONT_KEYS = SIGNATURE_FONTS.map(({ key }) => key);
export const DEFAULT_SIGNATURE_FONT = 'homemade_apple';
export const getSignatureFont = (key) => SIGNATURE_FONTS.find((font) => font.key === key) ?? SIGNATURE_FONTS[0];
export const isSeatApplicationSignatureRequired = (termApplications) => termApplications.some(({ seatApplicationTemplate }) => seatApplicationTemplate.requiresSignature);
export const DEFAULT_SIGNATURE_TERMS = 'By typing your name below you certify that the information in this application is true and complete to the best of your knowledge, and agree that this typed signature has the same effect as a handwritten one.';
export const resolveSignatureTerms = (signatureTerms) => signatureTerms?.trim() || DEFAULT_SIGNATURE_TERMS;
export const getSeatApplicationSignatureTerms = (termApplications) => [
    ...new Set(termApplications
        .filter(({ seatApplicationTemplate }) => seatApplicationTemplate.requiresSignature)
        .map(({ seatApplicationTemplate }) => resolveSignatureTerms(seatApplicationTemplate.signatureTerms))),
];
// Shaped as a react-dropzone `accept` map. SVG is excluded deliberately: it can carry script.
export const SIGNATURE_IMAGE_TYPES = {
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/webp': ['.webp'],
};
export const SIGNATURE_IMAGE_EXTENSIONS = Object.values(SIGNATURE_IMAGE_TYPES).flat();
export const MAX_SIGNATURE_IMAGE_BYTES = 5 * 1024 * 1024;
export const isSignatureImageFilename = (filename) => SIGNATURE_IMAGE_EXTENSIONS.some((extension) => filename.toLowerCase().endsWith(extension));
// English Metric Units per inch — the unit Word uses for drawing extents.
export const EMU_PER_INCH = 914400;
export const SIGNATURE_BOX_INCHES = { width: 2, height: 0.75 };
// Aspect-only, so the result is identical at any source resolution and can never exceed the box.
export const toSignatureExtentEmu = ({ height, width }) => {
    const { height: boxHeight, width: boxWidth } = SIGNATURE_BOX_INCHES;
    const aspect = width / height;
    const inches = aspect > boxWidth / boxHeight
        ? { width: boxWidth, height: boxWidth / aspect }
        : { width: boxHeight * aspect, height: boxHeight };
    return {
        width: Math.round(inches.width * EMU_PER_INCH),
        height: Math.round(inches.height * EMU_PER_INCH),
    };
};
